import { Indicator } from "@mantine/core";
import { IconUser, IconMapPin, IconTag, IconMessage, IconPencil, IconLockOpen, IconPlayerPause, IconRepeat, IconCheck, IconAlarm, IconClipboardPlus, IconX, IconUsers, IconCalendarEvent, IconArchive } from "@tabler/icons-react";
import { EventDto, EventSource, EventTarget, EventType } from "../models/event.models";
import { WorkOrderStatus } from "../models/workorder.models";

export const getEventTypeDescription = (event: EventDto) => {
	switch (event.EventType) {
		case EventType.Assigned:
			return `Assigned`;
		case EventType.Commented:
			return 'Commented';
		case EventType.Created:
			return 'Created';
		case EventType.Declined:
			return 'Declined';
		case EventType.Deleted:
			return 'Deleted';
		case EventType.Requested:
			return 'Requested';
		case EventType.Updated:
			return 'Updated';
		case EventType.Approved:
			return 'Approved';
		case EventType.Overdue:
			return 'Overdue';
		default:
			return 'Unknown';
	}
};

export const getEventTypeIcon = (event: EventDto) => {
	switch (event.EventType) {
		case EventType.Created:
			return <IconCheck />;
		case EventType.Updated:
			return <IconPencil />;
		case EventType.Deleted:
			return <IconX />;
		case EventType.Commented:
			return <IconUser />;
		case EventType.Requested:
			return <IconClipboardPlus />;
		case EventType.Approved:
			return <IconCheck />;
		case EventType.Declined:
			return <IconX />;
		case EventType.Assigned:
			return <IconUser />;
		case EventType.Overdue:
			return <IconAlarm />;
		default:
			return <IconUser />;
	}
};

export const getEventSourceType = (event: EventDto) => {	
	if (event.SourceType == null) return 'Unknown';

	switch (event.SourceType) {
		case EventSource.None:
			return 'None';
		case EventSource.WorkOrder:
			return 'Work Order';
		case EventSource.Category:
			return 'Category';
		case EventSource.Location:
			return 'Location';
		case EventSource.User:
			return 'User';
		case EventSource.Team:
			return 'Team';
		default:
			return 'Unknown';
	}
};

export const getEventTargetDescription = (event: EventDto) => {
	if (event.TargetType == null) return 'Unknown';

	switch (event.TargetType) {
		case EventTarget.WorkOrder:
			return 'Work Order';
		case EventTarget.Category:
			return 'Category';
		case EventTarget.Location:
			return 'Location';
		case EventTarget.User:
			return 'User';
		case EventTarget.Team:
			return 'Team';
		case EventTarget.Title:
			return 'Title';
		case EventTarget.Description:
			return 'Description';
		case EventTarget.Status:
			return 'Status';
		case EventTarget.Priority:
			return 'Priority';
		default:
			return 'Unknown';
	}
}

export const getEventTargetIcon = (event: EventDto) => {
	if (event.TargetType == null) return <IconUser />;

	switch (event.TargetType) {
		case EventTarget.Location:
			return <IconMapPin size={18} />;
		case EventTarget.Category:
			return <IconTag size={18} />;
		case EventTarget.Comment:
			return <Indicator label={<IconMessage size={16} color="var(--mantine-primary-color-light-color)" />} color="rgba(255, 255, 255, 0)" offset={-2} zIndex={1}><IconUser size={18} /></Indicator>;
		case EventTarget.Title:
			return <IconPencil size={18} />;
		case EventTarget.Status:
			{
				switch (parseInt(event.TargetId)) {
					case WorkOrderStatus.Open:
						return <IconLockOpen size={18} />;
					case WorkOrderStatus.OnHold:
						return <IconPlayerPause size={18} />;
					case WorkOrderStatus.InProgress:
						return <IconRepeat size={18} />;
					case WorkOrderStatus.Completed:
						return <IconCheck size={18} />;
					case WorkOrderStatus.Archived:
						return <IconArchive size={18} />;
					default:
						return <IconPencil size={18} />;
				}
			}
		case EventTarget.Priority:
			return <IconPencil />;
		case EventTarget.StartedDate:
			return <IconCalendarEvent size={18} />;
		case EventTarget.DueDate:
			return <IconCalendarEvent size={18} />;
		case EventTarget.User:
			return <IconUser size={18} />;
		case EventTarget.Team:
			return <IconUsers size={18} />;
		default:
			return <IconUser size={18} />;
	}
};